import { render, staticRenderFns } from "./AdminAddFirstTimers.vue?vue&type=template&id=22ad8d84&scoped=true&"
import script from "./AdminAddFirstTimers.vue?vue&type=script&lang=js&"
export * from "./AdminAddFirstTimers.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddFirstTimers.vue?vue&type=style&index=0&id=22ad8d84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad8d84",
  null
  
)

export default component.exports